import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExhibService } from 'src/app/Services/Utilities/exhib.service';

@Component({
  selector: 'app-rubric',
  templateUrl: './rubric.component.html',
  styleUrls: ['./rubric.component.scss']
})
export class RubricComponent implements OnInit {

  mark: any;
  rubricType: any;
  constructor(
    private toast: ToastrService,
    private ex: ExhibService,
    private router: Router
  ) {
    if(!this.ex.exhib){
      this.router.navigate(['/innovation']);

    }
    if(this.ex.exhib)
      this.mark = this.ex.exhib;
    if(this.ex.rubric){
      this.rubricType = this.ex.rubric;
    }

    
  }

  ngOnInit(){

  }

  back(){
    this.router.navigate(['/innovation']);

  }

}
